module.exports = __webpack_public_path__ + "img/share.d41d8cd9.svg";